import React from 'react'
import styled from 'styled-components';
import { BlackAppStore, BlackGooglePlay, CongratsIcon, ProfileBg } from '../utils/Images';
import { useNavigate } from 'react-router-dom';

const Congratulations = () => {
  const navigate = useNavigate()
  return (
    <CongratulationWrapper>
      <div className='content'>
        <h1 className='heading'>Congratulations</h1>
        <p className='para-1'>Your first call has been scheduled</p>
        <div className='tick-img'>
          <img src={CongratsIcon} alt="" className='congratsImg' />
        </div>
        <p className='para-2'>Download the app to initiate the call</p>
        <div className='google-app-store'>
          <img src={BlackAppStore} alt="" />
          <img src={BlackGooglePlay} alt="" />
        </div>
        <div className='btn-div'>
          <button onClick={() => navigate("/landing/home")}>Home page</button>
        </div>
      </div>
    </CongratulationWrapper>
  )
}

export default Congratulations;

const CongratulationWrapper = styled.div`
  background: url(${ProfileBg});
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .content{
    max-width:518px;
    width: 60.8%;
    background:#fff;
    border-radius:16px;
    box-shadow: 0px 4px 14px 3px #00000040;
    padding: 67px 42px;

    @media (max-width: 600px){
      width:80%;
    }

    .heading{
      color:#000;
      font-weight:700;
      font-size:23px;
      text-align:center;
    }
    .para-1{
      color:#000;
      font-weight:400;
      font-size:23px;
      margin-top:26px;
      margin-bottom:56px;
      text-align:center;
    }
    .tick-img{
      display:flex;
      align-items:center;
      justify-content:center;
      width:100%;

      .congratsImg{
        width:132px;
        height:132px;
      }
    }
    .para-2{
      color:#000;
      font-weight:700;
      font-size:23px;
      margin-top: 46px;
      margin-bottom: 32px;
      text-align:center;
    }
    .google-app-store{
      display:flex;
      gap:13px;
      justify-content:center;

      @media (max-width: 452px){
        flex-direction:column;
        align-items:center;
      }

      img{
        width:211px;
        height:61px;

        @media (max-width: 860px){
          width:150px;
          height:45px;
        }
      }
    }
    .btn-div{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      margin-top:43px;

      button{
        background:#0DA982;
        border-radius:15px;
        height:48px;
        color:#fff;
        font-size:16px;
        font-weight:700;
        padding: 0px 58px;
        border:none;
        cursor:pointer;
      }
    }
  }
`;